import * as React from 'react';
import { RecommendationSource } from '../types/apiSchema';

export interface ITestConfig {
  recommendationSource?: RecommendationSource;
}

export const defaultTestConfig: ITestConfig = {};

export const AbTestContext: React.Context<ITestConfig> = React.createContext(defaultTestConfig);

const getTestConfig: () => ITestConfig = () => {
  let recommendationSource: RecommendationSource;
  const matches: string[] = window.location.href.match(/gce_rec=(\d+)/i);

  if (matches !== null) {
    const value: string = matches[1];
    switch (value) {
      case '0':
        recommendationSource = RecommendationSource.jetlore;
        break;
      case '1':
        recommendationSource = RecommendationSource.athena_shot;
        break;
      case '2':
      case '3':
        recommendationSource = RecommendationSource.athena_i2i;
        break;
      default:
        recommendationSource = RecommendationSource.athena_shot;
        break;
    }
  }

  return {
    recommendationSource,
  };
};

export const AbTestProvider: React.FunctionComponent = ({ children }) => {
  const [testConfig] = React.useState<ITestConfig>(getTestConfig());

  return <AbTestContext.Provider value={testConfig} children={children} />;
};
